import { useCalculator } from '../state/CalculatorProvider';

export function StepNav() {
  const { state, derived, back, attemptAdvance, config } = useCalculator();

  const isFirstStep = state.phase === 'steps' && state.stepIndex === 0 && !config.intro;
  const isLastStep = state.phase === 'steps' && state.stepIndex === derived.visibleSteps.length - 1;
  const nextLabel = derived.currentStep?.nextLabel ?? (isLastStep ? 'GET RESULTS' : 'NEXT');

  // Real bug found 2026-09-09 comparing HSA Savings against the live
  // production calculator: with resultsPlacement:'always', ResultsFrame is
  // already permanently rendered regardless of `phase` (see
  // CalculatorApp.tsx's showResults), so the last step's "GET RESULTS"
  // button advances phase from 'steps' to 'results' — a transition nothing
  // on screen actually depends on. The button was rendering anyway,
  // clickable but functionally dead, on a calculator whose whole design
  // point (per the architecture doc) is that no submit gate exists at all.
  // Savings has exactly one step, so this hid its only nav button entirely,
  // matching production having none.
  const nextIsMeaningless = isLastStep && config.resultsPlacement === 'always';
  if (isFirstStep && nextIsMeaningless) return null;

  return (
    <div className="hsab-calc__step-nav">
      {!isFirstStep && (
        <button type="button" className="hsab-calc__step-nav-back" onClick={back}>
          BACK
        </button>
      )}
      {!nextIsMeaningless && (
        <button type="button" className="hsab-calc__step-nav-next" onClick={attemptAdvance}>
          {nextLabel}
        </button>
      )}
    </div>
  );
}
